import React, { useState, forwardRef, useImperativeHandle, useRef } from 'react';
import { errorToast } from '../../utils/helper';
import { CSVLink } from 'react-csv';

const ImportQuestion = forwardRef(({ onSubmit, sampleData, headers, filename }, ref) => {
  const [file, setFile] = useState(null);
  const fileInputRef = useRef();

  // Expose reset method to parent
  useImperativeHandle(ref, () => ({
    reset: () => {
      setFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  }));

  const handleFileUpload = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    } else {
      setFile(null);
    }
  };

  return (
    <>
      <div className="bg-white rounded-lg shadow p-6 m-4">
        <div className="mb-8">
          <div className="flex flex-col items-center">
            <label className="block text-lg font-medium text-gray-700 w-full md:w-2/4 text-left mb-2">
              CSV Questions File
            </label>

            <input
              type="file"
              onChange={handleFileUpload}
              ref={fileInputRef}
              className="input-company w-full md:w-2/4"
            />

            <div className="flex justify-between w-full md:w-2/4 mt-4">
              <button
                type="button"
                onClick={() => {
                  if (!file) {
                    errorToast('Please select a file first');
                    return;
                  }
                  onSubmit(file);
                }}
                className="btn-primary w-full sm:w-auto block"
              >
                Upload CSV file
              </button>

              {sampleData && headers && (
                <CSVLink
                  data={sampleData}
                  headers={headers}
                  filename={filename}
                  className="bg-shoorah-active text-white text-sm sm:px-10 py-2 w-full sm:w-auto rounded-full block flex items-center justify-center"
                >
                  <svg className="mr-2 w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M8 10V3h4v7h3l-5 5-5-5h3zM4 18h12v-2H4v2z" />
                  </svg>
                  Download Sample File
                </CSVLink>
              )}
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-2xl font-semibold text-black-500 mb-4">
            How to convert CSV in to Unicode (For Non English)
          </h3>
          <ol className="list-decimal list-inside text-gray-700 space-y-4 text-base">
            <li>Fill the data in excel sheet which format we provided</li>
            <li>
              Save the file as <strong>Unicode Text (*.txt)</strong>
            </li>
            <li>Open .txt file in Notepad</li>
            <li>Replace Tab spaces with commas ( , )</li>
            <li>
              Save as .txt file with <strong>UTF-8</strong> encoding
            </li>
            <li>Change extension from .txt to .csv</li>
            <li>Now import this .csv file</li>
          </ol>
          <a
            href="https://www.ablebits.com/office-addins-blog/convert-excel-csv/"
            className="text-blue-500 underline mt-4 inline-block"
          >
            For more info
          </a>
        </div>
      </div>
    </>
  );
});

export default ImportQuestion;
